import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface RegistrationMarkProps {
    className?: string
}

// A printer's registration mark, used as a separator in moving type.
const RegistrationMark: FC<RegistrationMarkProps> = ({ className }): ReactNode => (
    <svg aria-hidden='true' viewBox='0 0 24 24' className={cn('shrink-0', className)}>
        <circle cx='12' cy='12' r='6.5' fill='none' stroke='currentColor' strokeWidth='1.6' />
        <path d='M12 0v24M0 12h24' stroke='currentColor' strokeWidth='1.6' />
    </svg>
)

export default RegistrationMark
